export const TESTIMONIAL_ENUM = {
  STUDENT: 'Student',
  PARENT: 'Parent',
}
